// NE login SDK — centralized constants (single source of truth).
// Override any of these per-product by passing options to the SDK functions.

/** NE UserCenter base + paths (account login / user info). */
export const NE_UC_BASE = "https://uc.inoteexpress.com";
export const NE_UC_LOGIN_PATH = "/user/passwordlogin";
export const NE_UC_USERINFO_PATH = "/user/info";

/** CARSI (SSO) authorize endpoint + fixed OAuth params (per NE spec). */
export const NE_CARSI_AUTHORIZE = "https://sp-inoteexpress.carsi.edu.cn/api/authorize";
export const NE_CARSI_CLIENT_ID = "inoteexpress";
export const NE_CARSI_STATE = "oauth";

/** AI gateway (OpenAI-compatible). Built-in model billed to the NE account. */
export const NE_GATEWAY_BASE = "https://gateway.inoteexpress.com/v1";
/** Test-line gateway (intranet). Swap NE_GATEWAY_BASE → this when testing. */
export const NE_GATEWAY_TEST_BASE = "http://192.168.1.31:9999/v1";

/** app_source agreed with the gateway (TokenLedger app id). */
export const NE_APP_SOURCE = "flylatex";

/** The single built-in model: backend auto-routes the real model, so the id is
 *  a fixed placeholder; NE_BUILTIN_MODEL_NAME is what the UI should display. */
export const NE_BUILTIN_MODEL_ID = "gpt-4o";
export const NE_BUILTIN_MODEL_NAME = "内置模型";

/** Public key (uc.inoteexpress.com) used to RSA-encrypt the password. */
export const NE_PUBLIC_KEY =
  "-----BEGIN PUBLIC KEY-----\n" +
  "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDeoikuCMBQvmHtWc/6Z1jN3yP1\n" +
  "eLn2OgxJs40FrKOZfINk8HIDf9oVnbrkieVQs5NV6cfvnNf+VtYz7I9XJqx5DlCR\n" +
  "wnuo/quB2SEfHK7RtcJGfpqhrm1dkXwKa8HDOy3f6E38Qr0AXBjMW94Yb8URmLiQ\n" +
  "sGgngAdq0qtjX8irOwIDAQAB\n" +
  "-----END PUBLIC KEY-----";
